<template>
  <el-dialog :title="template.id ? '编辑' : '新增'" :visible.sync="visible" width="400px" :close-on-click-modal="false">
    <el-form label-width="100px" :rules="realRule">
      <el-form-item label="面单尺寸" prop="template" v-if="printBusinessType == 1">
        <el-select v-model="template.size" filterable :disabled="!!template.id">
          <el-option :label="`${item.width}*${item.height}`" :value="index" v-for="(item, index) in sheetSizeList"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="环节" prop="template" v-else>
        <el-select v-model="template.nodeType" filterable :disabled="!!template.id">
          <el-option label="简单检品打印" :value="1"></el-option>
          <el-option label="水洗标打印" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="方向" prop="direction" v-if="printBusinessType == 1">
        <el-radio v-model="template.direction" :label="1">纵向</el-radio>
        <el-radio v-model="template.direction" :label="2">横向</el-radio>
      </el-form-item>
      <el-form-item label="业务类型" prop="systemSource" v-else>
        <div style="margin: auto;float: left;margin-left: 20px;">
          <el-radio v-model="template.systemSource" :label="1" :disabled="!!template.id">D2C</el-radio>
          <el-radio v-model="template.systemSource" :label="2" :disabled="!!template.id">B2B</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="打印机" prop="printer">
        <el-select v-model="template.printer" filterable @visible-change="getPrinter">
          <el-option :label="item" :value="item" :key="item" v-for="item in printerList"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="text-align: right;margin-top: 40px;">
      <el-button @click="visible = false;" style="margin: 10px;">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { createPrintConfig, editPrintConfig } from '@/apis/configure'
import { getMacAddress, getPrinterList } from "@/apis/autoPrint.js"
import {autoGetMac} from"@/utils/autoPrint"
import { sheetSizeList } from "./InterListData"
export default {
  name: "configDialog",
  props: {
    printBusinessType: {
      type: Number,
      default: () => { return 0 }
    }
  },
  data() {
    return {
      visible: false,
      sheetSizeList,
      template: {
        size: '',
        direction: '',
        printer: '',
      },
      printerList: [],
      rules:{
        template:[{required: true,message: '请选择面单尺寸', trigger: 'blur'}],
        direction:[{required: true,message: '请选择方向', trigger: 'blur'}],
        printer:[{required: true,message: '请选择打印机', trigger: 'blur'}]
      }
    }
  },
  mounted() {
  },
  computed:{
    realRule: function (){
      return this.printBusinessType == 2?{...this.rules,systemSource:[{required: true,message: '请选择业务类型', trigger: 'blur'}]}:{...this.rules}
    }
  },
  methods: {
    open(template) {
      this.template = {
        size: '',
        direction: '',
        printer: '',
        ...template
      }
      this.visible = true
    },
    async submit() {
      let mac = await autoGetMac()
      if (mac && mac.data) {
        let params = {
          macAddress: mac.data,
          // printPaperSizeWide: this.sheetSizeList[this.template.size].width,
          // printPaperSizeHigh: this.sheetSizeList[this.template.size].height,
          printBusinessType: this.printBusinessType,
          ...this.template
        }
        if(this.printBusinessType == 1){
          params.printPaperSizeWide = this.sheetSizeList[this.template.size].width
          params.printPaperSizeHigh = this.sheetSizeList[this.template.size].height
        }
        if(this.printBusinessType == 2){
          params.nodeName = this.template.nodeType == 1?'简单检品打印':'水洗标打印'
          params.printPaperSizeWide = this.template.nodeType == 2?'30':this.template.systemSource == 1?'50':'101.6'
          params.printPaperSizeHigh = this.template.nodeType == 2?'103':this.template.systemSource == 1?'30':'101.6'
        }
        let api = this.template.id ? editPrintConfig : createPrintConfig
        api(params).then(res => {
          if (res.success) {
            this.$message.success('成功')
            this.visible = false;
            this.$emit('overEmit')
          }
        })
      }
    },
    getPrinter(v) {
      if(!v){
        return
      }
      getPrinterList().then(res => {
        this.printerList = res.data
      })
    }
  },
}

</script>